<template>
  <!-- The markers after a recipient's label in the internal-alarm picker.
       An app recipient is a person's phone, not a box on a wall: it receives a
       critical push and can acknowledge. Every SecurApp row is a phone — a
       virtual device or a handset paired with a device token — so both carry
       the marker; a paused virtual device stays in the list but cannot be
       reached, so it is marked as such. The selected chip (`chip`) carries the
       paused marker too, so a paused recipient already on the list reads as
       paused without opening the tree. -->
  <span>
    <span
      v-if="!chip && isApp"
      class="ml-1 align-middle text-xxs uppercase tracking-wide rounded px-1 py-0.5"
      :class="paused ? 'bg-gray-200 text-gray-600' : 'bg-blue-100 text-blue-700'"
    >
      {{ paused ? $t("alarm_info.app_recipient_paused") : $t("alarm_info.app_recipient") }}
    </span>
    <span
      v-if="chip && paused"
      class="ml-1 align-middle text-xxs uppercase tracking-wide rounded px-1 py-0.5 bg-gray-200 text-gray-600"
    >{{ $t("alarm_info.app_recipient_paused") }}</span>
    <span
      v-if="undeliverable"
      class="ml-1 align-middle text-xxs uppercase tracking-wide rounded px-1 py-0.5 bg-red-100 text-red-700"
    >{{ $t("alarm_info.app_recipient_not_delivered") }}</span>
  </span>
</template>

<script>
import { isVirtualDevice } from "@/utils/virtualDevice";

export default {
  name: "AppRecipientBadge",
  props: {
    node: { type: Object, required: true },
    chip: { type: Boolean, default: false },
  },
  computed: {
    isApp() {
      return !!this.node.raw && this.node.raw.type === "SecurApp";
    },
    paused() {
      return isVirtualDevice(this.node.raw) && this.node.raw.virtual_status !== "active";
    },
    // a phone on a source whose fan-out cannot reach it (sourceDeliversToApps
    // in the device forms)
    undeliverable() {
      return !!this.node.raw && !!this.node.raw.appUndeliverable;
    },
  },
};
</script>
